import { LegalBackLink } from "@/components/legal-back-link";
import { LegalFooter } from "@/components/legal-footer";

const H1 = "text-3xl font-bold tracking-tight";
const H2 = "text-xl font-semibold mt-10 mb-3";
const P = "leading-relaxed text-muted-foreground";

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen flex items-start justify-center py-12 px-4">
      <div className="w-full max-w-3xl">
        <div className="mb-6">
          <LegalBackLink />
        </div>

        <header className="mb-10">
          <h1 className={H1}>Terms of Service</h1>
          <p className="mt-2 text-sm text-muted-foreground">Last updated: 2026-05-04</p>
        </header>

        <article>
          <p className={P}>
            These Terms of Service ("Terms") govern your access to and use of the Quantfolio
            Platform ("Service"), operated by Quantfolio AS ("we", "us", "our"). By accessing or
            using the Service you agree to be bound by these Terms.
          </p>

          <h2 className={H2}>1. Use of the Service</h2>
          <p className={P}>
            You may use the Service only in compliance with these Terms and applicable laws. You are
            responsible for any activity that occurs under your account and for keeping your
            credentials confidential.
          </p>

          <h2 className={H2}>2. Accounts</h2>
          <p className={P}>
            You must provide accurate information when creating an account. We may suspend or
            terminate accounts that violate these Terms or that we reasonably believe are being used
            in a manner that creates risk for us or other users.
          </p>

          <h2 className={H2}>3. Customer data</h2>
          <p className={P}>
            You retain ownership of the data you submit to the Service. We process customer data on
            your behalf in accordance with our Privacy Policy and applicable agreements.
          </p>

          <h2 className={H2}>4. Disclaimer</h2>
          <p className={P}>
            The Service is provided "as is" without warranties of any kind. To the fullest extent
            permitted by law, we disclaim all implied warranties, including merchantability and
            fitness for a particular purpose.
          </p>

          <h2 className={H2}>5. Limitation of liability</h2>
          <p className={P}>
            To the fullest extent permitted by law, neither party will be liable for any indirect,
            incidental, special, consequential, or punitive damages, or any loss of profits or
            revenues.
          </p>

          <h2 className={H2}>6. Changes</h2>
          <p className={P}>
            We may update these Terms from time to time. Continued use of the Service after changes
            take effect constitutes acceptance of the updated Terms.
          </p>

          <h2 className={H2}>7. Contact</h2>
          <p className={P}>
            Questions about these Terms can be sent to{" "}
            <a href="mailto:hello@quantfol.io" className="underline hover:text-foreground">
              hello@quantfol.io
            </a>
            .
          </p>
        </article>

        <LegalFooter />
      </div>
    </div>
  );
}
